import { CircularProgress, Stack, TablePagination, TextField, Typography } from '@mui/material';
import UsersItem from './UsersItem';
import { useSelector } from 'src/redux/store';
import useTable from 'src/hooks/useTable';
import { useEffect, useState } from 'react';
import { User } from 'src/redux/slices/dashboard/users';

export default function RegistersTab() {
  const {
    page,
    rowsPerPage,
    onChangePage,
    onChangeRowsPerPage,
    setPage
  } = useTable(); 

  const [usersFilter, setUsersFilter] = useState('moreRecently');
  const [sortedUsers, setSortedUsers] = useState<User[]>([]);
  const { users, isLoading } = useSelector((state) => state.users);

  useEffect(() => {
    let sorted = [];
    switch(usersFilter){
      case 'alphabeticalOrder':
        sorted = users.slice().sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'lessRecently':
        sorted = users.slice().sort((a, b) => a.id - b.id);
        break;
      case 'moreRecently':
        sorted = users.slice().sort((a, b) => b.id - a.id);
        break;
      case 'moreStudiesNumber':
        sorted = users.slice().sort((a, b) => (b.studiesCount || 0) - (a.studiesCount || 0));
        break;
      case 'lessStudiesNumber':
        sorted = users.slice().sort((a, b) => (a.studiesCount || 0) - (b.studiesCount || 0));
      break;
      default:
        sorted = users.slice().sort((a, b) => b.id - a.id);
    }
    setPage(0);
    setSortedUsers(sorted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usersFilter, users]);

  return isLoading
    ? <CircularProgress />
    : <>
      <Stack direction='row' spacing={4} alignItems='center'>
          <Typography variant='h6'>
            Filtros:
          </Typography>
          <TextField
            select
            label='Ordene Por'
            value={usersFilter}
            onChange={(e) => {setUsersFilter(e.target.value)}}
            SelectProps={{ native: true }}
          >
           <option value='alphabeticalOrder'>Ordem Alfabética</option>
           <option value='moreRecently'>Mais Recentes</option>
           <option value='lessRecently'>Mais antigos</option>
           <option value='moreStudiesNumber'>Maior número de estudos</option>
           <option value='lessStudiesNumber'>Menor número de estudos</option>
          </TextField>
        </Stack>

      {sortedUsers?.filter((_data, index) => index >= page * rowsPerPage && index < (page + 1) * rowsPerPage).map((user) =>
        <UsersItem key={`${user.id}-${user.uid}`} user={user} />
      )}
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={sortedUsers?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
        labelRowsPerPage='Resultados por Página'
        labelDisplayedRows={({ from, to, count }) => {
          return `${from}–${to} de ${count !== -1 ? count : `Mais de ${to}`}`;
        }}
      />
    </>
}
